import { Duration } from 'dayjs/plugin/duration';

import { SDuration } from '@summit/core';
import { MileageFormatter, SummitFormattedText } from '@summit/models';

import { EboTenantItemTo } from '../base-classes/ebo-tenant-item-to';

export class MaintItem extends EboTenantItemTo {
  mmrNameOverride: string;
  allowMultiple: boolean;
  order: number;
  hideFromBoard: boolean;

  //metrics
  mileage: number;
  mileageThresholdFlag: number;
  mileageThresholdWarn: number;
  mileageThresholdAlarm: number;
  duration: Duration;
  durationThresholdFlag: Duration;
  durationThresholdWarn: Duration;
  durationThresholdAlarm: Duration;

  includeOnMMR: boolean;
  includeOnSSI: boolean;
  disabled: boolean;

  get durationInDays(): number | undefined {
    if (!this.duration) return undefined;
    return this.duration.asDays();
  }
  set durationInDays(value: number | undefined) {
    if (!value) this.duration = undefined;
    this.duration = SDuration.new({ day: value });
  }

  get durationThresholdFlagInDays(): number | undefined {
    if (!this.durationThresholdFlag) return undefined;
    return this.durationThresholdFlag.asDays();
  }
  set durationThresholdFlagInDays(value: number | undefined) {
    if (!value) this.durationThresholdFlag = undefined;
    this.durationThresholdFlag = SDuration.new({ day: value });
  }
  get durationThresholdWarnInDays(): number | undefined {
    if (!this.durationThresholdWarn) return undefined;
    return this.durationThresholdWarn.asDays();
  }
  set durationThresholdWarnInDays(value: number | undefined) {
    if (!value) this.durationThresholdWarn = undefined;
    this.durationThresholdWarn = SDuration.new({ day: value });
  }

  get durationThresholdAlarmInDays(): number | undefined {
    if (!this.durationThresholdAlarm) return undefined;
    return this.durationThresholdAlarm.asDays();
  }
  set durationThresholdAlarmInDays(value: number | undefined) {
    if (!value) this.durationThresholdAlarm = undefined;
    this.durationThresholdAlarm = SDuration.new({ day: value });
  }

  get mileageThresholds(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.mileageThresholdFlag) response.AddKeyValues(`Flag`, `${MileageFormatter(this.mileageThresholdFlag)} Mi.`);
    if (this.mileageThresholdWarn) response.AddKeyValues(`Warn`, `${MileageFormatter(this.mileageThresholdWarn)} Mi.`);
    if (this.mileageThresholdAlarm)
      response.AddKeyValues(`Alarm`, `${MileageFormatter(this.mileageThresholdAlarm)} Mi.`);
    return response;
  }

  get durationThresholds(): SummitFormattedText {
    const response = new SummitFormattedText();
    if (this.durationThresholdFlag) response.AddKeyValues(`Flag`, `${this.durationThresholdFlag.asDays()} Days`);
    if (this.durationThresholdWarn) response.AddKeyValues(`Warn`, `${this.durationThresholdWarn.asDays()} Days`);
    if (this.durationThresholdAlarm) response.AddKeyValues(`Alarm`, `${this.durationThresholdAlarm.asDays()} Days`);
    return response;
  }

  get usage(): string {
    const response = [];
    if (this.includeOnMMR) response.push('MMR');
    if (this.includeOnSSI) response.push('SSI');
    if (this.allowMultiple) response.push('Allow Multiple');
    return response.join(', ');
  }

  constructor(jsonData?: Partial<MaintItem>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.duration) this.duration = SDuration.new(jsonData.duration);
      if (jsonData.durationThresholdFlag) this.durationThresholdFlag = SDuration.new(jsonData.durationThresholdFlag);
      if (jsonData.durationThresholdWarn) this.durationThresholdWarn = SDuration.new(jsonData.durationThresholdWarn);
      if (jsonData.durationThresholdAlarm) this.durationThresholdAlarm = SDuration.new(jsonData.durationThresholdAlarm);
    }
    this.includeOnMMR ??= true;
    this.includeOnSSI ??= true;
    this.disabled ??= false;
  }

  toShortString(): string {
    return this.name;
  }

  get mmrDisplayString(): string {
    return this.mmrNameOverride && this.mmrNameOverride.length > 0 ? this.mmrNameOverride : this.name;
  }
}
